import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IAppDB } from '@/shared/lib/db';

export type UseCaseInput = void;
export type UseCaseOutput = void;

export class ClearCartUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private db: IAppDB;

  constructor(db: IAppDB) {
    this.db = db;
  }

  async execute(): Promise<UseCaseOutput> {
    // Limpa todos os itens do carrinho
    await this.db.items.clear();

    return void 0;
  }
}
